import 'babel-polyfill'
import Vue from 'vue'
import router from './router'
import VueTk from '@moke/vue-tk'
import App from './App.vue'
import config from './config'
import './assets/scss/main.scss'
import store from '../src/store/index'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import VECharts from 'vue-echarts'
const ECharts = require('echarts')
Vue.component('ve-chart', VECharts)

Vue.config.productionTip = false
Vue.prototype.$config = config
Vue.prototype.$echarts = ECharts

let plusReady = new Promise((resolve) => {
  if (!VueTk.tkUa.isPlus) resolve()
  if (window.plus) resolve()
  document.addEventListener('plusready', resolve, false)
})

// const Bus = new Vue()

Vue.use(Viewer)
Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})

async function init () {
  for (let pluginName of config.plugins) {
    let plugin = require('./plugins/' + pluginName)
    if (plugin && plugin.default && typeof plugin.default === 'function') {
      await plugin.default()
    }
  }
  await plusReady

  Vue.use(Viewer)
  Viewer.setDefaults({
    Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
  })
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
init()
export default Vue.prototype
